let url = "";
let mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCR_ANXyci3y67vqYyxSbosjjJXxDF8x4w";

if (process.env.NODE_ENV === "development") {
  url = "http://localhost:8000";
} else {
  url = "https://api.choff.com.br";
}

export const Constants = {
  url: url,
  baseUrl: url + "/api/admin",
  mapsApiKey,
};

export const mesesAbrev = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

export const LABEL_TIPO_VEICULO = {
  BLINDADO: "Blindado",
  NAO_BLINDADO: "Não blindado",
  VAN: "Van",
};

export const STATUS_LABEL_VEICULO = {
  PENDENTE_APROVACAO: { label: "Pendente", className: "badge-warning" },
  PENDENTE_REAVALIACAO: { label: "Pendente de reavaliação", className: "badge-warning" },
  ATIVO: { label: "Ativo", className: "badge-success" },
  INATIVO: { label: "Inativo", className: "badge-danger" },
  REPROVADO: { label: "Reprovado", className: "badge-danger" },
  DOCUMENTO_VENCIDO: { label: "Documento vencido", className: "badge-danger" },
};

export const COMBUSTIVEL_OPCOES = [
  { value: "GASOLINA", label: "Gasolina" },
  { value: "ALCOOL", label: "Etanol" },
  { value: "DIESEL", label: "Diesel" },
  { value: "FLEX", label: "Flex" },
  { value: "HIBRIDO", label: "Híbrido" },
  { value: "ELETRICO", label: "Elétrico" },
  { value: "GNV", label: "GNV" },
  { value: "OUTRO", label: "Outro" },
];

export const LABEL_TAE_TIPO = {
  DATA_ESPECIFICA: "Data específica",
  DIA_SEMANA: "Dia da semana",
};

export const LABEL_TAE_TIPO_MODIFICADOR = {
  MULTIPLICADOR: "Multiplicador de tarifa (x)",
  ADICIONAL_FIXO_PERCENTUAL: "Adicional fixo percentual",
  ADICIONAL_FIXO_VALOR: "Adicional fixo valor",
  DESCONTO_PERCENTUAL: "Desconto percentual",
  DESCONTO_VALOR: "Desconto valor",
};

export const NOMES_DIA_SEMANA = {
  0: "Domingo",
  1: "Segunda-feira",
  2: "Terça-feira",
  3: "Quarta-feira",
  4: "Quinta-feira",
  5: "Sexta-feira",
  6: "Sábado",
};

export const DURACAO_TARIFA_OPCOES = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const ANTECEDENCIA_CANCELAMENTO_OPCOES = [3, 6, 12, 24];

export const MULTIPLICADOR_OPCOES = {
  1.5: "1,5",
  2: "2,0",
  2.5: "2,5",
  3: "3,0",
  3.5: "3,5",
  4: "4,0",
  4.5: "4,5",
  5: "5,0",
};

export const LISTA_UFS = [
  "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT",
  "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO",
];

export const FILTRO_TIPO_OPCOES = [
  { value: "", label: "Todos" },
  { value: "ativo", label: "Ativo" },
  { value: "inativo", label: "Inativo" },
];

export const STATUS_LABEL_MOTORISTA = {
  PENDENTE_APROVACAO: { label: "Pendente", className: "badge-warning" },
  ATIVO: { label: "Ativo", className: "badge-success" },
  INATIVO: { label: "Inativo", className: "badge-danger" },
  REPROVADO: { label: "Reprovado", className: "badge-danger" },
};

export const TIPO_PESSOA = {
  PJ: "Pessoa Jurídica",
  PF: "Pessoa Física",
};

export const STATUS_VIAGEM_OPCOES = [
  { value: "", label: "Todos" },
  { value: "SOLICITADA", label: "Pendente" },
  { value: "ACEITA", label: "Agendada" },
  { value: "EM_ANDAMENTO", label: "Em andamento" },
  { value: "FINALIZADA", label: "Finalizada" },
  { value: "CANCELADA_PASSAGEIRO", label: "Cancelada" },
  { value: "CANCELADA_MOTORISTA", label: "Cancelada" },
  { value: "CANCELADA_SISTEMA", label: "Cancelada" },
];

export const STATUS_MOTORISTA_VIAGEM_OPCOES = [
  { value: "", label: "Todos" },
  { value: "NAO_INICIADO", label: "Não iniciado" },
  { value: "A_CAMINHO", label: "A caminho" },
  { value: "VIAGEM_INICIADA", label: "Viagem iniciada" },
  { value: "FINALIZADO", label: "Finalizado" },
  { value: "CANCELADO", label: "Cancelado" },
];

export const STATUS_LABEL_VIAGEM = {
  SOLICITADA: { label: "Pendente", className: "badge-warning" },
  ACEITA: { label: "Agendada", className: "badge-info" },
  EM_ANDAMENTO: { label: "Em andamento", className: "badge-primary" },
  FINALIZADA: { label: "Finalizada", className: "badge-success" },
  CANCELADA_PASSAGEIRO: { label: "Cancelada", className: "badge-danger" },
  CANCELADA_MOTORISTA: { label: "Cancelada", className: "badge-danger" },
  CANCELADA_SISTEMA: { label: "Cancelada", className: "badge-danger" },
};

export const STATUS_MOTORISTA_VIAGEM_LABEL = {
  NAO_INICIADO: { label: "Não iniciado", className: "badge-secondary" },
  A_CAMINHO: { label: "A caminho", className: "badge-info" },
  VIAGEM_INICIADA: { label: "Viagem iniciada", className: "badge-primary" },
  FINALIZADO: { label: "Finalizado", className: "badge-success" },
  CANCELADO: { label: "Cancelado", className: "badge-danger" },
};

export const STATUS_PAGAMENTO_OPCOES = [
  { value: "", label: "Todos" },
  { value: "PENDENTE", label: "Pendente" },
  { value: "APROVADO", label: "Aprovado" },
  { value: "REPROVADO", label: "Reprovado" },
  { value: "EM_PROCESSAMENTO", label: "Em processamento" },
  { value: "PAGO", label: "Pago" },
  { value: "NAO_APLICAVEL", label: "Não aplicável" },
];

export const STATUS_COMPROVANTE_LABEL = {
  NAO_ENVIADO: { label: "Comprovante não enviado", className: "badge-secondary" },
  AGUARDANDO_APROVACAO: { label: "Aguardando aprovação", className: "badge-warning" },
  APROVADO: { label: "Comprovante aprovado", className: "badge-success" },
  REPROVADO: { label: "Comprovante reprovado", className: "badge-danger" },
};

export const STATUS_LABEL_PAGAMENTO = {
  PENDENTE: { label: "Pendente", className: "badge-warning" },
  APROVADO: { label: "Aprovado", className: "badge-success" },
  REPROVADO: { label: "Reprovado", className: "badge-danger" },
  EM_PROCESSAMENTO: { label: "Em processamento", className: "badge-primary" },
  PAGO: { label: "Pago", className: "badge-success" },
  NAO_APLICAVEL: { label: "Não aplicável", className: "badge-secondary" },
};

export const textoExclusao = {
  title: "Atenção!",
  text: "Tem certeza que deseja remover?",
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  cancelButtonText: "Não",
  confirmButtonText: "Sim",
};
